import React, { useState } from 'react';

import Lead from '../../components/Lead/Lead';
import Header from '../../components/Header/Header';

import {
  TabContent,
  TabPane,
} from 'reactstrap';


export default function Business() {
  const [activeTab, setActiveTab] = useState('1');


  return (
    <>
      <Header title="Cadastrar" />

      <TabContent activeTab={activeTab} className="block-person">
        <TabPane tabId="1" style={{ marginTop: '10px' }}>
          <Lead />
        </TabPane>

      </TabContent>
    </>
  )
}